(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[52],{

/***/ 11318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ RecentNewsList; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var _hooks_useMpocketScript__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98259);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var RecentNewsList = function RecentNewsList() {
  (0,_hooks_useMpocketScript__WEBPACK_IMPORTED_MODULE_1__/* .useMpocketScript */ .k)('//irpocket.com/141A/irpocket/config-utils-main.js'); // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main.js')

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(NewsList, {
    id: "irp-top-list"
  });
};
var NewsList = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "RecentNewsList__NewsList",
  componentId: "sc-1ffy42j-0"
})(["display:flex;flex-direction:column;gap:30px;@media screen and (max-width:1047px){gap:24px;}> article{padding-bottom:30px;:not(:last-child){border-bottom:1px solid ", ";}@media screen and (max-width:1047px){padding-bottom:24px;}> a{display:flex;cursor:pointer;gap:50px;&:hover > div > h3{> svg{fill:", ";}> p{text-decoration:underline;color:", ";> span{color:", ";display:inline-block;}}}@media screen and (max-width:1047px){flex-direction:column;row-gap:14px;}> time{font-weight:700;font-size:14px;line-height:1.6;letter-spacing:0;color:", ";}> div{display:flex;flex-direction:column;row-gap:14px;> ul{display:flex;flex-wrap:wrap;gap:12px;> li{font-size:13px;text-align:center;line-height:1;color:", ";list-style:none;min-width:82px;padding:6px 13px;border:1pt solid;border-radius:2pt;border-color:", ";}}> h3{display:flex;gap:10px;transition:fill 0.3s ease;@media screen and (max-width:1047px){font-size:15px;line-height:24px;letter-spacing:0;}> svg{fill:", ";width:12px;height:28px;flex-shrink:0;}> p{font-size:16px;letter-spacing:0.64px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:15px;}> span{font-weight:500;font-size:13px;line-height:1.6;color:", ";margin-left:10px;@media screen and (max-width:1047px){font-size:11px;}}}}}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.backgroundBlue */ .r.colors.backgroundBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.hoverLightBlue */ .r.colors.hoverLightBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textSecond */ .r.colors.textSecond);

/***/ }),

/***/ 32682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ ir; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/utils/date.ts
var utils_date = __webpack_require__(16645);
// EXTERNAL MODULE: ./src/utils/routes.ts
var routes = __webpack_require__(97749);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 5 modules
var toConsumableArray = __webpack_require__(76687);
// EXTERNAL MODULE: ./src/components/elements/Button/index.tsx
var Button = __webpack_require__(96738);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Ir/CalenderCard.tsx








var calenderLink = routes/* IR_TOP_ROUTE.subdirectories.6.path */.kd.subdirectories[6].path;
var CalenderCard = function CalenderCard(_ref) {
  var items = _ref.items;
  var maxLength = 3;

  var displayItems = (0,toConsumableArray/* default */.Z)(items).sort(function (a, b) {
    return new Date(b.published).getTime() - new Date(a.published).getTime();
  }).slice(0, maxLength);

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Card, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
      children: "IR\u30AB\u30EC\u30F3\u30C0\u30FC"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(CalenderList, {
      children: displayItems.map(function (item, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)("li", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("time", {
            children: formatDate(item.published)
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            href: item.link,
            target: item.target,
            children: item.title
          })]
        }, index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: calenderLink,
      passHref: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(LinkButton, {
          btnStyle: "transparent",
          children: "IR\u30AB\u30EC\u30F3\u30C0\u30FC"
        })
      })
    })]
  });
};

var formatDate = function formatDate(date) {
  return new Date(date).toLocaleDateString("zh-CN", {
    timeZone: "Asia/Tokyo",
    year: "numeric",
    month: "long",
    day: "numeric"
  });
};

var Card = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "CalenderCard__Card",
  componentId: "sc-vsj3c7-0"
})(["display:flex;flex-direction:column;align-items:center;padding:22px 20px;gap:20px;background:", ";border-radius:8px;"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "CalenderCard__Title",
  componentId: "sc-vsj3c7-1"
})(["display:flex;flex-direction:column;align-items:center;padding:0px 0px 12px;width:100%;height:38px;border-bottom:1px solid ", ";font-size:22px;font-weight:700;line-height:1.2;@media screen and (max-width:1047px){height:36px;font-size:20px;}"], theme/* theme.colors.grey */.r.colors.grey);
var CalenderList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "CalenderCard__CalenderList",
  componentId: "sc-vsj3c7-2"
})(["display:flex;flex-direction:column;align-items:flex-start;gap:20px;padding:0px;width:200px;> li{display:flex;flex-direction:column;align-items:flex-start;padding:0px;gap:6px;font-size:15px;line-height:1.2;> time{font-size:12px;color:", ";}> div{}> a{transition:color 0.3s ease;&:hover{color:", ";text-decoration:underline;}}}@media screen and (max-width:1047px){width:295px;}"], theme/* theme.colors.textSecond */.r.colors.textSecond, theme/* theme.colors.lightBlue */.r.colors.lightBlue);
var LinkButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
  displayName: "CalenderCard__LinkButton",
  componentId: "sc-vsj3c7-3"
})(["width:200px;height:42px;padding:7px 26px 9px;font-weight:500;font-size:16px;line-height:1;background-color:#ffffff;@media screen and (max-width:1047px){width:295px;height:42px;}"]);
;// CONCATENATED MODULE: ./src/components/pages/Ir/MonthlySalesCard.tsx








var monthlySalesLink = routes/* IR_TOP_ROUTE.subdirectories.5.path */.kd.subdirectories[5].path;
var MonthlySalesCard = function MonthlySalesCard(_ref) {
  var date = _ref.date,
      yearPercent = _ref.yearPercent;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(MonthlySalesCard_Card, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(MonthlySalesCard_Title, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
        children: "\u6708\u6B21\u58F2\u4E0A\u9AD8\u901F\u5831"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
        children: [(0,utils_date/* formatDate */.p6)(date, 'yyyy年MM月'), "\u5EA6"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Explanation, {
      children: "\u65E2\u5B58\u5E97\u58F2\u4E0A\u9AD8\uFF08\u524D\u5E74\u540C\u6708\u6BD4\uFF09"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Difference, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: Number(yearPercent).toFixed(1)
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
        children: "%"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: monthlySalesLink,
      passHref: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(MonthlySalesCard_LinkButton, {
          btnStyle: "transparent",
          children: "\u6708\u6B21\u58F2\u4E0A\u9AD8\u901F\u5831"
        })
      })
    })]
  });
};
var MonthlySalesCard_Card = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "MonthlySalesCard__Card",
  componentId: "sc-1gttpn2-0"
})(["display:flex;flex-direction:column;align-items:center;padding:22px 20px;gap:10px;background:", ";border-radius:8px;"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var MonthlySalesCard_Title = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MonthlySalesCard__Title",
  componentId: "sc-1gttpn2-1"
})(["display:flex;flex-direction:column;align-items:center;padding-bottom:12px;width:100%;border-bottom:1px solid ", ";color:", ";text-align:center;height:57px;@media screen and (max-width:1047px){height:55px;}> h2{font-weight:700;font-size:22px;line-height:1.2;@media screen and (max-width:1047px){font-size:20px;}}> span{font-weight:500;font-size:12px;line-height:1.6;}"], theme/* theme.colors.grey */.r.colors.grey, theme/* theme.colors.textTitle */.r.colors.textTitle);
var Explanation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MonthlySalesCard__Explanation",
  componentId: "sc-1gttpn2-2"
})(["height:28px;padding-top:4px;padding-bottom:10px align-items:center;font-weight:500;font-size:12px;line-height:1.2;color:", ";"], theme/* theme.colors.textSecond */.r.colors.textSecond);
var Difference = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MonthlySalesCard__Difference",
  componentId: "sc-1gttpn2-3"
})(["height:40px;display:flex;flex-direction:row;gap:5px;justify-content:center;align-items:flex-end;padding-bottom:10px;@media screen and (max-width:1047px){height:40px;}> div{font-weight:700;font-size:30px;line-height:1;color:", ";}> span{font-weight:500;font-size:13px;line-height:1.5;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var MonthlySalesCard_LinkButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
  displayName: "MonthlySalesCard__LinkButton",
  componentId: "sc-1gttpn2-4"
})(["width:200px;height:42px;padding:11px 26px 13px;font-weight:500;font-size:16px;line-height:1;background-color:#ffffff;@media screen and (max-width:1047px){width:295px;height:42px;}"]);
// EXTERNAL MODULE: ./src/components/pages/Ir/RecentNewsList.tsx
var RecentNewsList = __webpack_require__(11318);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/pages/Ir/StockPriceInfoCard.tsx








var stockPriceLink = routes/* IR_TOP_ROUTE.subdirectories.4.path */.kd.subdirectories[4].path;
var StockPriceInfoCard = function StockPriceInfoCard() {
  var id = (0,react.useId)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StockPriceInfoCard_Card, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StockPriceInfoCard_Title, {
      id: id,
      children: "\u682A\u4FA1\u60C5\u5831"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Iframe, {
      id: "irpocket-stock-board-pc",
      src: "//irpocket.com/stock-chart/141As.html",
      height: "150",
      "aria-labelledby": id
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: stockPriceLink,
      passHref: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(StockPriceInfoCard_LinkButton, {
          btnStyle: "transparent",
          children: "\u682A\u4FA1\u30C1\u30E3\u30FC\u30C8"
        })
      })
    })]
  });
};
var StockPriceInfoCard_Card = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "StockPriceInfoCard__Card",
  componentId: "sc-1wiu6s2-0"
})(["display:flex;flex-direction:column;align-items:center;padding:22px 20px;gap:10px;background:", ";border-radius:8px;"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var Iframe = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
  displayName: "StockPriceInfoCard__Iframe",
  componentId: "sc-1wiu6s2-1"
})(["width:100%;"]);
var StockPriceInfoCard_Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "StockPriceInfoCard__Title",
  componentId: "sc-1wiu6s2-2"
})(["font-size:22px;font-weight:700;line-height:1.2;padding:0px 0px 12px;text-align:center;width:100%;box-sizing:border-box;border-bottom:1px solid ", ";@media screen and (max-width:1047px){font-size:20px;}"], theme/* theme.colors.grey */.r.colors.grey);
var StockPriceInfoCard_LinkButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
  displayName: "StockPriceInfoCard__LinkButton",
  componentId: "sc-1wiu6s2-3"
})(["width:200px;height:42px;padding:7px 26px 9px;font-weight:500;font-size:16px;line-height:1;background-color:#ffffff;@media screen and (max-width:1047px){width:295px;height:42px;}"]);
// EXTERNAL MODULE: ./src/components/elements/LinkCard/index.tsx + 1 modules
var LinkCard = __webpack_require__(53300);
// EXTERNAL MODULE: ./src/components/elements/LinkCardList/index.tsx
var LinkCardList = __webpack_require__(57613);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
// EXTERNAL MODULE: ./src/components/layouts/Ir/index.tsx
var Ir = __webpack_require__(87661);
// EXTERNAL MODULE: ./src/components/layouts/Ir/Mpocket/DownloadZipButton.tsx
var DownloadZipButton = __webpack_require__(76278);
// EXTERNAL MODULE: ./src/components/elements/RoundedLabel/index.tsx
var RoundedLabel = __webpack_require__(51342);
;// CONCATENATED MODULE: ./src/components/pages/Ir/CmsLinkCard.tsx







var CmsLinkCard = function CmsLinkCard(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      link = _ref.link,
      imgPath = _ref.imgPath;
  return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
    href: link,
    passHref: true,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageWrapper, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: imgPath,
            width: "74",
            height: "70",
            alt: ""
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 16,
            pc: 7
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Subtitle, {
          children: subtitle
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 17,
            pc: 11
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(RoundedLabel/* RoundedLabel */.I, {
          children: title
        })]
      })
    })
  });
};
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "CmsLinkCard__StyledLink",
  componentId: "sc-1nwodgf-0"
})(["display:block;width:316px;&:hover > div{> div > img{opacity:0.6;transition:opacity 0.25s ease;}> div:last-of-type{background:", ";transition:background 0.25s ease;opacity:1;}}&:hover > div > div:first-of-type{> div > img{opacity:0.6;transition:opacity 0.25s ease;}> div:nth-of-type(2){background:", ";transition:background 0.25s ease;}}@media screen and (max-width:1047px){width:335px;}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue, theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CmsLinkCard__Wrapper",
  componentId: "sc-1nwodgf-1"
})(["width:316px;height:188px;background:", ";border-radius:8px;padding:18px 21px 21px 21px;display:flex;flex-direction:column;@media screen and (max-width:1047px){width:100%;height:208px;padding:24px 12px 18px;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CmsLinkCard__ImageWrapper",
  componentId: "sc-1nwodgf-2"
})(["display:flex;justify-content:center;transition:opacity 0.25s ease;"]);
var Subtitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "CmsLinkCard__Subtitle",
  componentId: "sc-1nwodgf-3"
})(["font-size:15px;font-weight:700;color:", ";text-align:center;@media screen and (max-width:1047px){font-size:18px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
// EXTERNAL MODULE: ./src/hooks/useMpocketScript.ts
var useMpocketScript = __webpack_require__(98259);
;// CONCATENATED MODULE: ./src/components/pages/Ir/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }























var irTopMessageLink = routes/* IR_TOP_ROUTE.subdirectories.0 */.kd.subdirectories[0];
var irFinancialEventLink = routes/* IR_TOP_ROUTE.subdirectories.1 */.kd.subdirectories[1];
var irInvestorLink = routes/* IR_TOP_ROUTE.subdirectories.2 */.kd.subdirectories[2];
var irNewsLink = routes/* IR_TOP_ROUTE.subdirectories.3.path */.kd.subdirectories[3].path;
var IrPage = function IrPage(_ref) {
  var irFinancialEvent = _ref.irFinancialEvent,
      monthlySales = _ref.monthlySales,
      irCalendar = _ref.irCalendar;
  (0,useMpocketScript/* useMpocketScript */.k)('//irpocket.com/141A/irpocket/config-utils-main.js'); // useMpocketScript('//irpocket.com/5882/irpocket/config-utils-main.js')

  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '株主・投資家向け情報',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u306E\u7686\u69D8\u306B\u5411\u3051\u305F\u60C5\u5831\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: 'ir/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(layout/* ImageTitleLayout */.Cr, {
      title: "Investor Relations",
      subTitle: "\u682A\u4E3B\u30FB\u6295\u8CC7\u5BB6\u5411\u3051\u60C5\u5831",
      imgUrl: "/images/top-ir.webp",
      breadCrumbs: breadCrumbs,
      isRequiredBackground: false,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LinkCardList/* LinkCardList */.s, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LinkCard/* LinkCard */.k, {
            title: irTopMessageLink.name,
            link: irTopMessageLink.path,
            imgPath: irTopMessageLink.imagePath,
            isExternalLink: irTopMessageLink.isExternalLink
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(CmsLinkCard, {
            title: irFinancialEvent.title,
            subtitle: "\n                ".concat((0,utils_date/* formatDate */.p6)(irFinancialEvent.date, 'yyyy年MM月dd日'), " \n                ").concat(irFinancialEvent.held, "\n                "),
            link: irFinancialEventLink.path,
            imgPath: irFinancialEventLink.imagePath
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(LinkCard/* LinkCard */.k, {
            title: irInvestorLink.name,
            link: irInvestorLink.path,
            imgPath: irInvestorLink.imagePath,
            isExternalLink: irInvestorLink.isExternalLink
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 70,
            pc: 97
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(TwoColumns, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(LeftColumn, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionButtonTitle, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle, {
                  children: "\u6700\u65B0IR\u8CC7\u6599"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(DownloadZipButton/* DownloadZipButton */.V, {
                  id: "irp-library-latest-zip"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(DocumentList, {
                id: "irp-library-quarter-list"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(Onlyload, {
                id: "irp-library-term-list"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
              h: {
                sp: 70,
                pc: 80
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(SectionButtonTitle, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle, {
                  children: "IR\u30CB\u30E5\u30FC\u30B9"
                }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
                  href: irNewsLink,
                  passHref: true,
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ShowAllButton, {
                      btnStyle: "transparent",
                      children: "\u4E00\u89A7\u3092\u898B\u308B"
                    })
                  })
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(RecentNewsList/* RecentNewsList */.M, {})]
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(RightColumn, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StockPriceInfoCard, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
              h: {
                sp: 30,
                pc: 44
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(MonthlySalesCard, _objectSpread({}, monthlySales)), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
              h: {
                sp: 30,
                pc: 44
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(CalenderCard, {
              items: irCalendar
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
              h: {
                sp: 30,
                pc: 44
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://sharedresearch.jp/ja/companies/141A",
              target: "_blank",
              rel: "noopener noreferrer",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: "/images/shared_research_ja.png",
                style: {
                  width: "100%"
                }
              })
            })]
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ThreeImg, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("section", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(SectionButtonTitle, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle, {
              children: "\u793E\u5916\u8A55\u4FA1"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
              href: "./ir/evaluation",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ShowAllButton, {
                  btnStyle: "transparent",
                  children: "\u4E00\u89A7\u3092\u898B\u308B"
                })
              })
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          style: {
            display: "flex",
            flexWrap: "wrap",
            flex: "1 1 33.33%",
            order: 3
          },
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DivImg, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://jsite.mhlw.go.jp/fukuoka-roudoukyoku/content/contents/000393811.pdf",
              target: "_blank",
              rel: "noopener noreferrer",
              className: "pdf_after",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                style: {
                  height: "185px",
                  margin: "0 auto"
                },
                src: "/images/ir-approval.png",
                alt: ""
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DivImg, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://jsite.mhlw.go.jp/fukuoka-roudoukyoku/content/contents/001294466.pdf",
              target: "_blank",
              rel: "noopener noreferrer",
              className: "pdf_after",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                style: {
                  height: "185px",
                  margin: "0 auto"
                },
                src: "/images/ir-certification.jpg",
                alt: ""
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DivImg, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
              href: "https://pdf.irpocket.com/C141A/jQ9P/ZH6w/duVd.pdf",
              target: "_blank",
              rel: "noopener noreferrer",
              className: "pdf_after",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                style: {
                  height: "185px",
                  margin: "0 auto"
                },
                src: "/images/ir-winning.png",
                alt: ""
              })
            })
          })]
        })]
      })]
    })]
  });
};
var ThreeImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Ir__ThreeImg",
  componentId: "sc-162iuin-0"
})(["width:1040px;margin:0 auto 130px;@media screen and (max-width:1047px){width:calc(100% - 40px);margin:0 auto;}"]);
var DivImg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Ir__DivImg",
  componentId: "sc-162iuin-1"
})(["width:33.33%;text-align:center;min-width:220px;margin-top:50px;@media screen and (max-width:1047px){margin-bottom:30px;margin-top:15px;}@media screen and (max-width:700px){width:100%;}&:hover{a{text-decoration:underline;color:", ";}.pdf_after:after{background:url('/images/external-link-hoverblue.svg') no-repeat;}}.pdf_after{&:after{content:'';background:url('/images/external-link-black.svg') no-repeat;width:12px;height:12px;margin-left:8px;display:inline-block;}}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var TwoColumns = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Ir__TwoColumns",
  componentId: "sc-162iuin-2"
})(["display:flex;@media screen and (max-width:1047px){flex-direction:column;row-gap:60px;}"]);
var LeftColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Ir__LeftColumn",
  componentId: "sc-162iuin-3"
})(["width:745px;margin-right:55px;@media screen and (max-width:1047px){width:100%;}"]);
var SectionButtonTitle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Ir__SectionButtonTitle",
  componentId: "sc-162iuin-4"
})(["display:flex;flex-direction:row;align-items:center;padding:0px 0px 60px;gap:30px;@media screen and (max-width:1047px){padding:0px 0px 30px;gap:16px;}"]);
var SectionTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Ir__SectionTitle",
  componentId: "sc-162iuin-5"
})(["font-weight:700;font-size:32px;color:", ";@media screen and (max-width:1047px){padding:0px;font-weight:700;font-size:24px;line-height:130%;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var DocumentList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "Ir__DocumentList",
  componentId: "sc-162iuin-6"
})(["@media screen and (max-width:1047px){display:flex;flex-direction:column;gap:14px;}> li{display:flex;align-items:center;width:100%;:not(:last-child){border-bottom:1px solid ", ";}@media screen and (max-width:1047px){flex-direction:column;padding-top:0px;padding-bottom:14px;gap:2px;align-items:flex-start;}> a{transition:color 0.3s ease;display:flex;gap:50px;width:100%;padding-top:18px;padding-bottom:20px;@media screen and (max-width:1047px){flex-direction:column;row-gap:2px;}&:hover > h3{> svg{fill:", ";}> p{text-decoration:underline;color:", ";> span{color:", ";display:inline-block;}}}> time{font-weight:700;font-size:14px;line-height:1.6;}> h3{display:flex;gap:10px;@media screen and (max-width:1047px){font-size:15px;line-height:24px;letter-spacing:0;}> svg{fill:", ";width:12px;height:28px;flex-shrink:0;}> p{font-size:16px;letter-spacing:0.64px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:15px;}> span{font-weight:500;font-size:13px;line-height:1.6;color:", ";margin-left:10px;@media screen and (max-width:1047px){font-size:11px;}}}}}}"], theme/* theme.colors.backgroundBlue */.r.colors.backgroundBlue, theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue, theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue, theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.textTitle */.r.colors.textTitle, theme/* theme.colors.textSecond */.r.colors.textSecond);
var Onlyload = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Ir__Onlyload",
  componentId: "sc-162iuin-7"
})(["display:none;"]);
var ShowAllButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* Button */.z).withConfig({
  displayName: "Ir__ShowAllButton",
  componentId: "sc-162iuin-8"
})(["padding:11px 26px 13px 26px;width:135px;height:40px;font-size:16px;font-weight:500;@media screen and (max-width:1047px){padding:2px 18px 4px 18px;font-size:13px;width:104px;height:32px;}"]);
var RightColumn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Ir__RightColumn",
  componentId: "sc-162iuin-9"
})(["width:240px;@media screen and (max-width:1047px){width:335px;align-items:center;margin:0 auto;}"]); // 第１期四半期決算説明会を非表示
// const HiddenCmsLinkCard = styled.div`
//   display: none;
// `
;// CONCATENATED MODULE: ./src/pages/ir/index.tsx



var ir_Ir = function Ir(_ref) {
  var irFinancialEvent = _ref.irFinancialEvent,
      monthlySales = _ref.monthlySales,
      irCalendar = _ref.irCalendar;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(IrPage, {
    irFinancialEvent: irFinancialEvent,
    monthlySales: monthlySales,
    irCalendar: irCalendar
  });
};

var __N_SSG = true;
/* harmony default export */ var ir = (ir_Ir);

/***/ }),

/***/ 16645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ isEqualYear; },
/* harmony export */   "dG": function() { return /* binding */ isEqualMonth; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72167);

var formatDate = function formatDate(date, formatType) {
  try {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), formatType);
  } catch (e) {
    return date;
  }
};
var isEqualYear = function isEqualYear(date, year) {
  return formatDate(date, 'yyyy') === year;
};
var isEqualMonth = function isEqualMonth(date, month) {
  return formatDate(date, 'M') === month;
};

/***/ }),

/***/ 40808:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir",
      function () {
        return __webpack_require__(32682);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,9181,8517,2167,5548,1839,9774,2888,179], function() { return __webpack_exec__(40808); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);